<lib-cfi-file-upload 
  [configJson]="configJson"
  [allowPointerEvents]="allowPointerEvents"
  [enrollmentBuilderView]="enrollmentBuilderView"
  [isEnabled]="isEnabled"
  [showUploadProgress]="showUploadProgress"
  [class.pointers]="allowPointerEvents"
  (filesAdded)="onFilesAdded($event)"
  (filesChanged)="onFilesChanged($event)"
  (retryRequested)="onRetryRequested()">
</lib-cfi-file-upload>
